export default "__VITE_ASSET__a08f8ecd__"